import {ClaimMissionRewardResponse_ErrorResult} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';
import {
  COLORS,
  GenericIconName,
  Icon,
  SPACING,
  Text,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';

export const CoinsClaimPopupContentError: FC<
  ClaimMissionRewardResponse_ErrorResult
> = ({description, title}) => {
  return (
    <Wrapper>
      <StyledIcon
        asset={GenericIconName.AlertErrorFill}
        size="M"
        fill={COLORS['Alerts.Error.Primary']}
      />
      {title && (
        <StyledText size="px20" weight="mediumHeavy">
          {title}
        </StyledText>
      )}
      {description && (
        <StyledText size="px12" weight="mediumBold">
          {description}
        </StyledText>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 286px;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 50px ${SPACING['X.Xl']};
`;

const StyledIcon = styled(Icon)`
  margin-bottom: ${SPACING['Y.Md']};
`;

const StyledText = styled(Text)`
  text-align: center;
  line-height: 1.2;

  &:not(:first-child) {
    line-height: 1.5;
  }
`;
